import { render } from "./ScrollTop.vue?vue&type=template&id=a7149ae4&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=a7149ae4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7149ae4"]])

export default __exports__